import { routeConstants } from "services/keyConstants";

const baseUrl = `/${routeConstants.MAM_OF_EQUIPMENT}`;
export const GET_BY_ID = `${baseUrl}/`;
export const CREATE_LIST_OF_EQUIPMENTS = `${baseUrl}/`;
export const GET_BY_FORMAT_ID = `${baseUrl}/get-by-format-id`;
export const UPDATE_SPECIFIC_EQUIPMENT = `${baseUrl}/update-specific-for-equipment`;
export const DOWNLOAD = `${baseUrl}/download`;
export const DELETE_EQUIPMENT_DATA = `${baseUrl}/delete-equipment`;
export const GET_EQUIPMENT_LIST = `${baseUrl}/get-equipment`;
export const CREATE_EQUIPMENT_DATA = `${baseUrl}/create-report`;
export const UPDATE_REPORT_DATA = `${baseUrl}/update-calibration-date`;
export const UPDATE_EXTERNAL_DATA = `${baseUrl}/update-external-date`;
export const GET_DATA_BY_TYPE = `${baseUrl}/get-by-calibrationtype`;
export const CREATE_CALIBRATION_PLAN = `${baseUrl}/create-plan`;
export const FETCH_BY_MASTER_DOC_ID = `${baseUrl}/fetch-by-masterdoc`;
export const GET_FILTERED_DOCS = `${baseUrl}/get-filtered-docs`;
